<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- 개정 -->
          <c-card title="LBLREV" class="cardClassDetailForm revisionLayout" topClass="topcolor-orange" v-if="popupParam.opmGuidebookId">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="row">
                  <div class="col-2">
                    <!-- 개정번호 -->
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="LBLREVNO"
                      name="revisionNum"
                      v-model="data.revisionNum">
                    </c-text>
                  </div>
                  <div class="col-2">
                    <!-- 개정일시 -->
                    <c-text
                      :editable="false"
                      label="LBLREVPERIOD"
                      name="regDtStr"
                      v-model="data.regDtStr">
                    </c-text>
                  </div>
                  <div class="col-2">
                    <!-- 개정자 -->
                    <c-text
                      :editable="false"
                      label="LBLREVUSER"
                      name="regUserName"
                      v-model="data.regUserName">
                    </c-text>
                  </div>
                  <div class="col-6">
                    <!-- 개정사유 -->
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="LBLREVREASON"
                      name="revisionContent"
                      v-model="data.revisionContent">
                    </c-text>
                  </div>
                </div>
              </div>
              <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-top: -18px !important;" id="revdiv">
                <c-table
                  ref="revision"
                  title="개정이력"
                  tableId="revision"
                  topBorderClass="topcolor-orange"
                  :columns="gridrev.columns"
                  :data="gridrev.data"
                  gridHeight="150px"
                  :columnSetting="false"
                  :expandAll="false"
                  :isFullScreen="false"
                  :usePaging="false"
                  :hideBottom="true"
                  :filtering="false"
                  @rowClick="rowClickRev"
                >
                </c-table>
              </div> -->
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- 안전환경보건 규정 기본정보 -->
          <c-card title="LBL0010351" class="cardClassDetailForm">
            <template slot="card-select">
              <!-- 개정이력 -->
              <c-select
                :editable="!isRevision"
                v-if="popupParam.opmGuidebookId"
                :comboItems="gridrev.data"
                type="custom"
                typetext="LBL0010352"
                itemText="revisionNum"
                itemValue="opmGuidebookId"
                name="selectedopmGuidebookId"
                label=""
                v-model="selectedopmGuidebookId"
                @input="rowClickRev"
              ></c-select>
            </template>
            <template slot="card-button">
              <q-btn-group outline >
                <!-- 규정비교 -->
                <c-btn label="LBL0010353" icon="manage_search" @btnClicked="editorPop" v-if="editable" />
                <!-- 개정 -->
                <c-btn
                  v-show="editable && popupParam.opmGuidebookId && !isRevision"
                  label="LBLREV"
                  icon="restart_alt"
                  @btnClicked="setRevision" />
                <!-- 개정취소 -->
                <c-btn
                  v-show="editable && popupParam.opmGuidebookId && isRevision"
                  label="LBLREVCANCEL"
                  icon="restart_alt"
                  @btnClicked="cancelRevision" />
                <!-- 저장 -->
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <!-- 제목 -->
                <c-text
                  required
                  :editable="editable"
                  label="LBLTITLE"
                  name="guidebookName"
                  v-model="data.guidebookName">
                </c-text>
              </div>
              <div class="col-3">
                <!-- 분류번호 -->
                <c-text
                  required
                  :editable="editable"
                  label="LBL0010347"
                  name="guidebookNo"
                  v-model="data.guidebookNo">
                </c-text>
              </div>
              <div class="col-3">
                <!-- 승인자 -->
                <c-field 
                  type="user" 
                  :editable="editable"
                  label="LBLAPPROVER" 
                  name="approvalUserId" 
                  v-model="data.approvalUserId" />
              </div>
              <div class="col-3">
                <!-- 검토자 -->
                <c-field 
                  type="user" 
                  :editable="editable"
                  label="LBLREVIEWER" 
                  name="examineUserId" 
                  v-model="data.examineUserId" />
              </div>
              <div class="col-3">
                <c-plant
                  required
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-3">
                <!-- 사용여부 -->
                <c-radio
                  :editable="editable"
                  :comboItems="useFlagItems"
                  label="LBLUSEFLAG"
                  name="useFlag"
                  v-model="data.useFlag">
                </c-radio>
              </div>
              <div class="col-12">
                <!-- 규정내용 -->
                <c-textarea
                  type="editor"
                  :editable="editable"
                  label="LBL0010348"
                  name="remark"
                  v-model="data.remark">
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-12" style="margin-top:20px;">
          <!-- 관련 지침서 -->
          <c-upload 
            :attachInfo="attachInfo"
            :editable="editable"
            label="LBL0010354">
          </c-upload>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'inter-lock-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        opmGuidebookId: '',
      }),
    },
  },
  data() {
    return {
      selectedopmGuidebookId: null,
      attachable: false,
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'SAF_OPER_GUIDE_BOOK',
        taskKey: '',
        beforeTaskKey: '',
        isRev: false,
      },
      saveUrl: transactionConfig.sop.opm.guidebook.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      isRevision: false,
      data: {
        opmGuidebookId: '',
        plantCd: '',
        guidebookNo: '',
        guidebookName: '',
        approvalUserId: '',
        examineUserId: '',
        regUserId: '',
        chgUserId: '',
        useFlag: 'Y',
        remark: '',
        revisionNum: '',
        groupId: '',
        sysRevision: 1,
        revisionContent: '제정',
        regDtStr: '',
        regUserName: '',
        sopMocId: ''
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      gridrev: {
        columns: [
          {
            name: 'revisionNum',
            field: 'revisionNum',
            // 개정번호
            label: 'LBLREVNO',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'revisionContent',
            field: 'revisionContent',
            // 개정사유
            label: 'LBLREVREASON',
            align: 'left',
            sortable: true,
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            // 개정일시
            label: 'LBLREVPERIOD',
            style: 'width: 150px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            // 개정자
            label: 'LBLREVUSER',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
        ],
        data: [],
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      realKey: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.opm.guidebook.get.url;
      this.insertUrl = transactionConfig.sop.opm.guidebook.insert.url;
      this.updateUrl = transactionConfig.sop.opm.guidebook.update.url;
      this.revlistUrl = selectConfig.sop.opm.guidebook.rev.url;
      this.getRevUrl = selectConfig.sop.opm.guidebook.rev.get.url;
      this.getDetail(true);
    },
    getDetail(_check) {
      if (_check) {
        this.isRevision = false;
        this.editable = this.$route.meta.editable;
        if (this.popupParam.opmGuidebookId) {
          this.$http.url = this.$format(this.detailUrl, this.popupParam.opmGuidebookId);
          this.$http.type = 'GET';
          this.$http.request((_result) => {
            this.data = _result.data;
            // 상세팝업 최초작성/최근수정 정보 노출
            this.$emit('setRegInfo', _result.data)
            this.realKey = this.$_.cloneDeep(_result.data.opmGuidebookId)
            this.attachable = true,
            this.$set(this.attachInfo, 'taskKey', this.popupParam.opmGuidebookId)
            this.getRevList(_result.data.groupId);
          },);
        }
      } else {
        this.$http.url = this.$format(this.getRevUrl, this.popupParam.opmGuidebookId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          if (_result.data) {
            this.data = _result.data;
            if (_result.data.opmGuidebookId === this.realKey) {
              this.editable = this.$route.meta.editable;
              this.attachable = true,
              this.$set(this.attachInfo, 'taskKey', this.popupParam.opmGuidebookId)
            } else {
              this.editable = false;
              this.attachable = false,
              this.$set(this.attachInfo, 'taskKey', _result.data.opmGuidebookId)
            }
          }
        },);
      }
      this.selectedopmGuidebookId = this.popupParam.opmGuidebookId
    },
    saveData() {
      if (this.popupParam.opmGuidebookId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      let saveMsg = 'MSGSAVE';  // 저장하시겠습니까?
      if (this.isRevision) {
        saveMsg = 'MSGREVSAVE';
        // 현재버전을 개정하여 저장하시겠습니까?
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',  // 확인
            message: saveMsg,
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              // 개정시
              if (this.isRevision) {
                this.saveUrl = this.insertUrl;
                this.mappingType = 'POST';
                this.data.sysRevision = parseInt(this.data.sysRevision) + 1;
              }
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',  // 확인
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.opmGuidebookId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if(this.mappingType == 'POST') {
        this.$set(this.popupParam, 'opmGuidebookId', result.data)
        this.$set(this.attachInfo, 'taskKey', this.popupParam.opmGuidebookId)
        this.$set(this.attachInfo, 'isSubmit', uid())
      }
      /**
       * 첨부파일 셋팅
       */
      this.$set(this.attachInfo, 'beforeTaskKey', '')
      this.$set(this.attachInfo, 'isRev', false)
      this.getDetail(true);
    },
    setRevision() {
      this.$http.url = selectConfig.com.revision.getversion;
      this.$http.param = {revisionNum: this.data.revisionNum}
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data.revisionNum = _result.data;
        this.data.revisionContent = '';
        this.data.regDtStr = '';
        this.data.regUserName = '';
        this.isRevision = true;
        /**
         * 첨부파일 셋팅
         */
        this.$set(this.attachInfo, 'taskKey', '')
        this.$set(this.attachInfo, 'beforeTaskKey', this.popupParam.opmGuidebookId)
        this.$set(this.attachInfo, 'isRev', true)
      });
    },
    cancelRevision() {
      this.isRevision = false;
      /**
       * 첨부파일 셋팅
       */
      this.$set(this.attachInfo, 'taskKey', this.popupParam.opmGuidebookId)
      this.$set(this.attachInfo, 'beforeTaskKey', '')
      this.$set(this.attachInfo, 'isRev', false)
      this.getDetail(true);
    },
    getRevList(_groupId) {
      this.$http.url = this.revlistUrl;
      this.$http.type = 'GET';
      this.$http.param = {groupId: _groupId};
      this.$http.request((_result) => {
        this.gridrev.data = _result.data;
      },);
    },
    rowClickRev(row) {
      if (row) {
        if (row != this.popupParam.opmGuidebookId) {
          this.selectedopmGuidebookId = row;
          this.popupParam.opmGuidebookId = this.selectedopmGuidebookId
          this.getDetail(false);
          this.$set(this.attachInfo, 'taskKey', this.selectedopmGuidebookId)
        }
      }
    },
    editorPop() {
      this.popupOptions.target = () => import(`${"./safetyOperGuideBookEditor.vue"}`);
      this.popupOptions.title = 'LBL0010353';   // 규정 비교
      this.popupOptions.param = {
        groupId: this.data.groupId ? this.data.groupId : '',
        remark: this.data.remark ? this.data.remark : '',
        opmGuidebookId: this.popupParam.opmGuidebookId ? this.popupParam.opmGuidebookId : '',
      };
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  }
};
</script>
